import { createStore } from 'zustand';

interface FeatureFlags {
  enableRedirect?: boolean;
  enableAuth?: boolean;
}

export const useFeatureFlagContext = createStore<FeatureFlags>(() => ({
  enableRedirect: false,
  enableAuth: true,
}));

export const setStageOneFlag = (value: boolean) => {
  useFeatureFlagContext.setState((state) => ({ ...state, enableRedirect: value, enableAuth: !value }));
};
